import React from 'react';
import {
  Box,
  Button,
  Heading,
  Modal,
  ModalBody,
  ModalFooter,
  Text,
} from '@razorpay/blade/components';
import { overlayLayers } from 'constants/overlayLayers.generated';

export function ToggleSalaryStructureModal({
  isOpen,
  onClose,
  title,
  subtitle,
  description,
  onPrimaryButtonClick,
  isActive,
  onSecondaryButtonClick,
  isLoading,
}: {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  subtitle: string;
  description: string;
  onPrimaryButtonClick: () => void;
  onSecondaryButtonClick: () => void;
  isLoading: boolean;
  isActive: boolean;
}) {
  return (
    <Modal isOpen={isOpen} onDismiss={onClose} zIndex={overlayLayers.modal}>
      <ModalBody>
        <Box display="flex" flexDirection="column" gap="spacing.2">
          <Heading size="medium" weight="semibold">
            {title}
          </Heading>

          <Text
            size="small"
            weight="semibold"
            color="surface.text.gray.muted"
            marginTop="spacing.5">
            {subtitle}
          </Text>

          <Text size="medium" weight="regular" color="surface.text.gray.subtle">
            {description}
          </Text>
        </Box>
      </ModalBody>

      <ModalFooter>
        <Box display="flex" gap="spacing.3" justifyContent="flex-end" width="100%">
          <Button
            variant="tertiary"
            onClick={onSecondaryButtonClick}
            isDisabled={isLoading}
            isLoading={isLoading}>
            {'Close'}
          </Button>

          <Button
            onClick={onPrimaryButtonClick}
            isDisabled={isLoading}
            isLoading={isLoading}
            color={isActive ? 'negative' : 'positive'}>
            {isActive ? 'Disable now' : 'Enable now'}
          </Button>
        </Box>
      </ModalFooter>
    </Modal>
  );
}
